export const NO_CHANNELS_SELECTED = (
  <>
    <strong>No channels selected</strong> - Please select at least one channel in order to define venues. You can save
    this rule now, but it won&apos;t be published anywhere until destinations are assigned.
  </>
);

export const NO_VENUES_SELECTED = (
  <>
    <strong>No venues selected</strong> - Please select at least one venue in order to create the rule.
  </>
);

export const UNIQUE_ATTRIBUTE_RULE_NAME_ERROR = 'Attribute rule name must be unique';

export const HAS_RULES_CHIP = 'has rule(s)';

export const OVERRIDE_RULES_CHIP = 'Override rule(s)';
